"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _queryString = _interopRequireDefault(require("query-string"));

var _urlService = require("./urlService");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const createRequestConfig = ({
  bearerToken,
  params = {},
  headers = {},
  responseType
}) => {
  const config = {
    headers: { ...(bearerToken && {
        Authorization: `Bearer ${bearerToken}`
      }),
      Accept: "application/json",
      ...headers
    }
  };

  if (params) {
    config.params = { ...params
    };

    config.paramsSerializer = paramsToSerialize => _queryString.default.stringify(paramsToSerialize);
  }

  if (responseType) {
    config.responseType = responseType;
  }

  return config;
};

const axiosRequestBuilder = (apiBasePath, relativePath, bearerToken, params, headers, responseType) => {
  return {
    url: (0, _urlService.buildUrl)(apiBasePath, relativePath),
    requestConfig: createRequestConfig({
      bearerToken,
      params,
      headers,
      responseType
    })
  };
};

const validateParameters = (argumentLength, relativePath) => {
  if (argumentLength > 1) {
    throw `Only 1 parameter was expected for the API call, but ${argumentLength} were recieved.`;
  }

  if (relativePath === undefined) {
    throw `Relative path is missing or malformed: ${relativePath}`;
  }

  return;
};

class HttpClient {
  constructor(apiBasePath, getBearerToken) {
    if (!apiBasePath) throw new Error("missing apiBasePath");
    this.apiBasePath = apiBasePath;

    this.getBearerToken = path => {
      return getBearerToken && getBearerToken(path);
    };
  }

  async get({
    relativePath,
    params = {},
    headers = {},
    responseType
  }) {
    validateParameters(arguments.length, relativePath);
    const {
      url,
      requestConfig
    } = axiosRequestBuilder(this.apiBasePath, relativePath, await this.getBearerToken(relativePath), params, headers, responseType);
    return await _axios.default.get(url, requestConfig);
  }

  async post({
    relativePath,
    data,
    params = {},
    headers = {},
    responseType
  }) {
    validateParameters(arguments.length, relativePath);
    const {
      url,
      requestConfig
    } = axiosRequestBuilder(this.apiBasePath, relativePath, await this.getBearerToken(relativePath), params, headers, responseType);
    return await _axios.default.post(url, data, requestConfig);
  }

  async put({
    relativePath,
    data,
    params = {},
    headers = {},
    responseType
  }) {
    validateParameters(arguments.length, relativePath);
    const {
      url,
      requestConfig
    } = axiosRequestBuilder(this.apiBasePath, relativePath, await this.getBearerToken(relativePath), params, headers, responseType);
    return await _axios.default.put(url, data, requestConfig);
  }

  async patch({
    relativePath,
    data,
    params = {},
    headers = {},
    responseType
  }) {
    validateParameters(arguments.length, relativePath);
    const {
      url,
      requestConfig
    } = axiosRequestBuilder(this.apiBasePath, relativePath, await this.getBearerToken(relativePath), params, headers, responseType);
    return await _axios.default.patch(url, data, requestConfig);
  }

  async delete({
    relativePath,
    params = {},
    headers = {},
    responseType
  }) {
    validateParameters(arguments.length, relativePath);
    const {
      url,
      requestConfig
    } = axiosRequestBuilder(this.apiBasePath, relativePath, await this.getBearerToken(relativePath), params, headers, responseType);
    return await _axios.default.delete(url, requestConfig);
  }

}

exports.default = HttpClient;